import React from 'react';
import './TooltipContentItem.scss';

const TooltipContentItem: React.FC = props => {
  return <div className="TooltipContentItem">{props.children}</div>;
};

export default TooltipContentItem;
